jQuery(document).ready(function ($) {

    if($(window).width() < 768) {
        // Find all iframe videos(Vimeo/YouTube)
        var $videos = $("iframe[src^='https://player.vimeo.com'], iframe[src^='https://www.youtube.com']"),

        // The container element that has fluid width
        $container = $("iframe").parent();

        // Figure out and save aspect ratio for each video and remove hard coded width/height
        $videos.each(function() {
            var newWidth = $container.width();
            $(this).data('aspectRatio', this.height / this.width).removeAttr('height').removeAttr('width');
        //Add new width/height
            var $video = $(this);
            $video.width(newWidth).height(newWidth * $video.data('aspectRatio'));
        });
    }
});
